import {clone} from '@/utils/helpers'

export default (touristsData, offer) => {
    const tourists = clone(touristsData)
    const {onExtraBed, onWithoutPlace} = clone(offer)
    for (let i = tourists.length - 1; i > 0; i--) {
        const tourist = tourists[i]
        const onWithoutPlaceItem = onWithoutPlace?.find(
            ({type, quantity, age}) => tourist.type === type && tourist.age === age && quantity
        )
        if (onWithoutPlaceItem) {
            onWithoutPlaceItem.quantity--
            tourist.onWithoutPlace = true
        } else {
            delete tourist.onWithoutPlace
        }
    }
    for (let i = tourists.length - 1; i > 0; i--) {
        const tourist = tourists[i]
        const onExtraBedItem = onExtraBed?.find(
            ({type, quantity, age}) =>
                tourist.type === type && tourist.age === age && quantity && !tourist.onWithoutPlace
        )
        if (onExtraBedItem) {
            onExtraBedItem.quantity--
            tourist.onExtrabed = true
        } else {
            delete tourist.onExtrabed
        }
    }
    return tourists
}
